// extracted by mini-css-extract-plugin
export default {"content":"text-accordion_content__bZOb2"};